import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
 
const ReactQueryInput = ({
  heading,
  getDataFromChild,
  inputHeight,
  value,
  height,
}) => {
  const [editorContent, setEditorContent] = useState(value || "");
 
  // Update local state when the `value` prop changes
  useEffect(() => {
    setEditorContent(value || "");
  }, [value]);
 
  const handleEditorChange = (content) => {
    setEditorContent(content); // Update local state
    getDataFromChild(content); // Propagate the data to the parent
  };
 
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
  };
 
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];
 
  return (
    <div className="">
      <div className="content_label">{heading}</div>
      <ReactQuill
        style={{
          marginTop: "5px",
          display: "block",
          maxHeight: height ? height : "300px",
          overflowY: "auto",
        }}
        value={editorContent}
        onChange={handleEditorChange}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};
 
export default ReactQueryInput;